import { Route } from 'react-router-dom';
import DefaultLayout from '../../components/layouts/default-layout/DefaultLayout';
import { DefaultLayoutHeaderType } from '../../components/layouts/default-layout/DefaultLayout.models';
import DashboardRoute from '../DashboardRoute';
export default function BaseRoute() {

    return <>
        <Route element={<DefaultLayout showFooter={true} showDefaultHeader={DefaultLayoutHeaderType.showDefaultHeader} />}>
            <Route path="/Dashboard" element={<DashboardRoute />} />
        </Route>
    </>
}
